import { ca } from '@cian/analytics';

export const trackBookingSuccess = (label: string) => {
  ca('eventSite', {
    action: 'success_booking',
    category: 'booking',
    name: 'oldevent',
    label,
    useLastProducts: true,
  });
};
